"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
exports.default = react_1.default.memo(LastOnline);
function LastOnline(props) {
    return react_1.default.createElement(Typography_1.default, { variant: props.variant }, formatLastOnlineDate(props.minutesSinceLastOnline));
}
function formatLastOnlineDate(minutesSinceLastOnline) {
    if (isNaN(minutesSinceLastOnline)) {
        return "";
    }
    if (minutesSinceLastOnline < 2) {
        return "Online now";
    }
    let durationText;
    if (minutesSinceLastOnline < 60) {
        durationText = `${minutesSinceLastOnline} minutes`;
    }
    else {
        const hoursSinceLastOnline = Math.floor(minutesSinceLastOnline / 60);
        if (hoursSinceLastOnline === 1) {
            durationText = "1 hour";
        }
        else if (hoursSinceLastOnline < 24) {
            durationText = `${hoursSinceLastOnline} hours`;
        }
        else {
            const daysSinceLastOnline = Math.floor(hoursSinceLastOnline / 24);
            durationText = daysSinceLastOnline === 1
                ? "1 day"
                : `${daysSinceLastOnline} days`;
        }
    }
    return `Last online ${durationText} ago`;
}
